import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=216a6c1f"
import script from "./Trends.vue?vue&type=script&lang=js"
export * from "./Trends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports